/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Genderpreference1Inputs */

const en__field_genderpreference1 = /** @type {(inputs: _Field_Genderpreference1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender Preference`)
};

const de__field_genderpreference1 = /** @type {(inputs: _Field_Genderpreference1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlechtspräferenz`)
};

/**
* | output |
* | --- |
* | "Gender Preference" |
*
* @param {_Field_Genderpreference1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_genderpreference1 = /** @type {((inputs?: _Field_Genderpreference1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Genderpreference1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_genderpreference1(inputs)
	return de__field_genderpreference1(inputs)
});
export { _field_genderpreference1 as "_field_genderPreference" }